// LWS 365 Prompt Card Library - Full Dataset
// Auto-generated from the uploaded prompt deck data
// 
// Tier access:
//   - "free" themes: Available to all (January + February = 59 prompts)
//   - "basic" themes: Available to Pen Friend tier (March-June = +122 prompts)
//   - "full" themes: Available to Correspondent tier (July-December = all 365 prompts)

export const DECK_THEMES = [
  { month: "January", theme: "Letter to Your Future Self", tier: "free" },
  { month: "February", theme: "Love Letters", tier: "free" },
  { month: "March", theme: "Gratitude Letters", tier: "basic" },
  { month: "April", theme: "Encouragement", tier: "basic" },
  { month: "May", theme: "Mothers & Mentors", tier: "basic" },
  { month: "June", theme: "Friends Far Away", tier: "basic" },
  { month: "July", theme: "Letters Never Sent", tier: "full" },
  { month: "August", theme: "Younger Self", tier: "full" },
  { month: "September", theme: "Forgiveness", tier: "full" },
  { month: "October", theme: "Appreciation", tier: "full" },
  { month: "November", theme: "Someone Who Changed Your Life", tier: "full" },
  { month: "December", theme: "Letters for the Future", tier: "full" }
];

export const PROMPT_CARDS = [
  {
    "card": 1,
    "month": "January",
    "day": 1,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to yourself one year from today. Describe exactly where you are sitting right now, and what you hope has changed by the time you read this.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 2,
    "month": "January",
    "day": 2,
    "theme": "Letter to Your Future Self",
    "prompt": "Tell your future self the one thing you are most afraid to admit you want.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 3,
    "month": "January",
    "day": 3,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to the version of you who finally finished what you keep starting. Tell them what it took.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 4,
    "month": "January",
    "day": 4,
    "theme": "Letter to Your Future Self",
    "prompt": "Describe today's weather, your most-used mug, and the song stuck in your head \u2014 small anchors for a future reader to feel the room.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 5,
    "month": "January",
    "day": 5,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to yourself five years from now, listing what you hope you have let go of by then.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 6,
    "month": "January",
    "day": 6,
    "theme": "Letter to Your Future Self",
    "prompt": "Tell your future self about a decision you're sitting on right now. Ask them how it turned out.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 7,
    "month": "January",
    "day": 7,
    "theme": "Letter to Your Future Self",
    "prompt": "Write the letter you'd want to receive on a hard day next winter.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 8,
    "month": "January",
    "day": 8,
    "theme": "Letter to Your Future Self",
    "prompt": "Begin your letter with: \"By the time you read this, I hope you have stopped...\"",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 9,
    "month": "January",
    "day": 9,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to your future self about the person you are pretending not to miss.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 10,
    "month": "January",
    "day": 10,
    "theme": "Letter to Your Future Self",
    "prompt": "Tell yourself, ten years out, what you are most proud of this year \u2014 even if it seems small now.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 11,
    "month": "January",
    "day": 11,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to the future version of you who has finally said the hard thing out loud. Tell them what you'd want to ask, knowing they did.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 12,
    "month": "January",
    "day": 12,
    "theme": "Letter to Your Future Self",
    "prompt": "Describe your current morning routine in detail, so future-you can remember what an ordinary day once felt like.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 13,
    "month": "January",
    "day": 13,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to yourself at eighty. Ask what you should stop worrying about now.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 14,
    "month": "January",
    "day": 14,
    "theme": "Letter to Your Future Self",
    "prompt": "Tell your future self about a fear you're carrying. Ask them, gently, if it ever happened.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 15,
    "month": "January",
    "day": 15,
    "theme": "Letter to Your Future Self",
    "prompt": "Write the letter you'll open on your next birthday. Tell this year's self something it needs to hear.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 16,
    "month": "January",
    "day": 16,
    "theme": "Letter to Your Future Self",
    "prompt": "Describe a worry that feels enormous today. Write to your future self and ask if it still does.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 17,
    "month": "January",
    "day": 17,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to yourself five years ago. Tell them what you wish they'd known, then write to yourself five years ahead and ask the same of them.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 18,
    "month": "January",
    "day": 18,
    "theme": "Letter to Your Future Self",
    "prompt": "Tell your future self what you are choosing to begin this month, and why now.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 19,
    "month": "January",
    "day": 19,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to the self who will read this once the thing you're dreading is finally over.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 20,
    "month": "January",
    "day": 20,
    "theme": "Letter to Your Future Self",
    "prompt": "Describe, in detail, a place you want to have visited by the time you read this letter again.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 21,
    "month": "January",
    "day": 21,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to your future self about someone you love. Tell them what you don't want to forget about this season together.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 22,
    "month": "January",
    "day": 22,
    "theme": "Letter to Your Future Self",
    "prompt": "Tell yourself what \"enough\" looks like right now, so future-you has something to measure against.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 23,
    "month": "January",
    "day": 23,
    "theme": "Letter to Your Future Self",
    "prompt": "Write the letter you'd leave for yourself if you knew this year would be the one that changed everything.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 24,
    "month": "January",
    "day": 24,
    "theme": "Letter to Your Future Self",
    "prompt": "Describe the apartment, house, or room you live in now \u2014 the future you may have moved on from it entirely.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 25,
    "month": "January",
    "day": 25,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to yourself one decade from now. Ask what you wish you'd stopped apologizing for.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 26,
    "month": "January",
    "day": 26,
    "theme": "Letter to Your Future Self",
    "prompt": "Tell your future self about a risk you're considering. Ask if you took it.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 27,
    "month": "January",
    "day": 27,
    "theme": "Letter to Your Future Self",
    "prompt": "Write the letter you'd want waiting for you on the other side of the hardest week of this year.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 28,
    "month": "January",
    "day": 28,
    "theme": "Letter to Your Future Self",
    "prompt": "Describe what peace currently feels like to you, in case the definition changes.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 29,
    "month": "January",
    "day": 29,
    "theme": "Letter to Your Future Self",
    "prompt": "Write to your future self about the habit you're trying, again, to build. Tell them why this time feels different.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 30,
    "month": "January",
    "day": 30,
    "theme": "Letter to Your Future Self",
    "prompt": "Tell yourself, years from now, what you wish someone had told you at the start of this year.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 31,
    "month": "January",
    "day": 31,
    "theme": "Letter to Your Future Self",
    "prompt": "Write the final letter of the month to your future self: list everything you are choosing to carry into the next twelve months, and everything you are setting down.",
    "approach": "You're writing to someone who already exists \u2014 they just haven't lived this part yet. Write as if they're a few years younger than you, not a stranger.",
    "starters": [
      "By the time you read this,",
      "I want you to remember that",
      "Right now, I am..."
    ],
    "tip": "Include one detail from today \u2014 the weather, a song, what's on your desk \u2014 so it feels like a real moment, not a generic note.",
    "letter": {
      "author": "Marcus Aurelius",
      "recipient": "Himself",
      "year": "c. 170\u2013180 AD",
      "context": "As Roman emperor, Marcus Aurelius kept a private set of notes \u2014 never meant for an audience \u2014 in which he wrote to no one but himself, working out each morning how he meant to meet the day. Historians now call it the Meditations. It may be the oldest surviving letter to a future self.",
      "excerpt": "\u201cBegin the morning by saying to thyself, I shall meet with the busy, the ungrateful, the violent, the treacherous, the envious, the unsocial... I have seen the nature of the good that it is beautiful, and of the bad that it is ugly.\u201d",
      "tieBack": "Marcus Aurelius wrote to himself to prepare for a day he hadn't lived yet. Today's prompt asks you to do the same."
    },
    "tier": "free"
  },
  {
    "card": 32,
    "month": "February",
    "day": 1,
    "theme": "Love Letters",
    "prompt": "Write to someone you love about the specific way they make ordinary days better.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 33,
    "month": "February",
    "day": 2,
    "theme": "Love Letters",
    "prompt": "Tell someone the moment you knew you loved them \u2014 the small, unglamorous one, not the cinematic one.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 34,
    "month": "February",
    "day": 3,
    "theme": "Love Letters",
    "prompt": "Write a love letter to a friendship, not a romance.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 35,
    "month": "February",
    "day": 4,
    "theme": "Love Letters",
    "prompt": "Describe your partner's hands, or their laugh, or the way they say your name \u2014 something only you would notice.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 36,
    "month": "February",
    "day": 5,
    "theme": "Love Letters",
    "prompt": "Write to someone you've loved quietly for a long time without ever quite saying so.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 37,
    "month": "February",
    "day": 6,
    "theme": "Love Letters",
    "prompt": "Tell someone what you love about the way they argue, worry, or apologize.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 38,
    "month": "February",
    "day": 7,
    "theme": "Love Letters",
    "prompt": "Write a letter of love to your own body, addressed as if it were a person you've been hard on.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 39,
    "month": "February",
    "day": 8,
    "theme": "Love Letters",
    "prompt": "Describe the first home you shared with someone you love, room by room.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 40,
    "month": "February",
    "day": 9,
    "theme": "Love Letters",
    "prompt": "Write to a partner about a small daily ritual of yours together that you never want to lose.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 41,
    "month": "February",
    "day": 10,
    "theme": "Love Letters",
    "prompt": "Tell someone you love what you were like before you knew them, and what they changed.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 42,
    "month": "February",
    "day": 11,
    "theme": "Love Letters",
    "prompt": "Write a love letter to a city, a season, or a piece of music \u2014 something you love that isn't a person.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 43,
    "month": "February",
    "day": 12,
    "theme": "Love Letters",
    "prompt": "Describe what safety feels like with this person, in physical, specific terms.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 44,
    "month": "February",
    "day": 13,
    "theme": "Love Letters",
    "prompt": "Write to someone about the version of love you didn't believe in until you met them.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 45,
    "month": "February",
    "day": 14,
    "theme": "Love Letters",
    "prompt": "Tell a long-term partner one thing about them you still notice for the first time, years in.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 46,
    "month": "February",
    "day": 15,
    "theme": "Love Letters",
    "prompt": "Write a love letter to a pet who loved you uncomplicatedly.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 47,
    "month": "February",
    "day": 16,
    "theme": "Love Letters",
    "prompt": "Write to someone you love about a fight you had and what it taught you about loving them better.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 48,
    "month": "February",
    "day": 17,
    "theme": "Love Letters",
    "prompt": "Describe the smell, sound, or taste that reminds you most of someone you love.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 49,
    "month": "February",
    "day": 18,
    "theme": "Love Letters",
    "prompt": "Write to your child, born or not yet, about how you hope to love them.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 50,
    "month": "February",
    "day": 19,
    "theme": "Love Letters",
    "prompt": "Tell someone you love what you hope they never doubt about themselves.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 51,
    "month": "February",
    "day": 20,
    "theme": "Love Letters",
    "prompt": "Write a love letter to your younger self's idea of what love would feel like \u2014 tell them how it actually feels.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 52,
    "month": "February",
    "day": 21,
    "theme": "Love Letters",
    "prompt": "Describe a quiet, unremarkable evening with someone you love, in enough detail that they could relive it.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 53,
    "month": "February",
    "day": 22,
    "theme": "Love Letters",
    "prompt": "Write to someone about loving them through a season when neither of you was at your best.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 54,
    "month": "February",
    "day": 23,
    "theme": "Love Letters",
    "prompt": "Tell a friend you love them, plainly, without irony, the way you might if you knew it could be the last letter.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 55,
    "month": "February",
    "day": 24,
    "theme": "Love Letters",
    "prompt": "Write a love letter to the family you chose, rather than the one you were given.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 56,
    "month": "February",
    "day": 25,
    "theme": "Love Letters",
    "prompt": "Describe what you hope to still be doing together in thirty years.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 57,
    "month": "February",
    "day": 26,
    "theme": "Love Letters",
    "prompt": "Write to someone you loved and lost \u2014 through distance, death, or simply time \u2014 and say the thing love letters are for.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 58,
    "month": "February",
    "day": 27,
    "theme": "Love Letters",
    "prompt": "Tell someone you love what about them makes you braver.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 59,
    "month": "February",
    "day": 28,
    "theme": "Love Letters",
    "prompt": "Write the love letter you wish someone had written you, and then send it to them instead.",
    "approach": "Skip the grand statements and go straight for the specific. The smallest, truest detail says more than \"I love you\" ever can.",
    "starters": [
      "I love the way you",
      "I still think about the time you",
      "What I never tell you enough is"
    ],
    "tip": "Name one ordinary moment, not a special occasion \u2014 it proves you're paying attention all the time, not just on cue.",
    "letter": {
      "author": "Sullivan Ballou",
      "recipient": "His wife, Sarah Ballou",
      "year": "July 14, 1861",
      "context": "A week before the First Battle of Bull Run, Union Major Sullivan Ballou wrote home to his wife in Rhode Island. He was killed in the battle a week later. The letter was found among his belongings and never reached Sarah until after his death.",
      "excerpt": "\u201cI have no misgivings about, or lack of confidence in, the cause in which I am engaged, and my courage does not halt or falter... Sarah, my love for you is deathless, it seems to bind me to you with mighty cables that nothing but Omnipotence could break.\u201d",
      "tieBack": "Ballou wrote the letter he hoped he'd never have to send. Most love letters don't carry that weight \u2014 but they're worth writing as if they might."
    },
    "tier": "free"
  },
  {
    "card": 60,
    "month": "March",
    "day": 1,
    "theme": "Gratitude Letters",
    "prompt": "Write to someone who showed you kindness when you least expected it.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 61,
    "month": "March",
    "day": 2,
    "theme": "Gratitude Letters",
    "prompt": "Thank a teacher or mentor for advice you still follow, even now.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 62,
    "month": "March",
    "day": 3,
    "theme": "Gratitude Letters",
    "prompt": "Write to the stranger who once helped you in a way they probably forgot by dinner.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 63,
    "month": "March",
    "day": 4,
    "theme": "Gratitude Letters",
    "prompt": "Thank someone for believing in you before you believed in yourself.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 64,
    "month": "March",
    "day": 5,
    "theme": "Gratitude Letters",
    "prompt": "Write to a friend who stayed during the year everyone else found reasons to leave.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 65,
    "month": "March",
    "day": 6,
    "theme": "Gratitude Letters",
    "prompt": "Thank your body for a single specific thing it has carried you through.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 66,
    "month": "March",
    "day": 7,
    "theme": "Gratitude Letters",
    "prompt": "Write to someone who gave you your first real job, lesson, or chance.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 67,
    "month": "March",
    "day": 8,
    "theme": "Gratitude Letters",
    "prompt": "Thank a parent, guardian, or caregiver for one ordinary sacrifice you only understood later.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 68,
    "month": "March",
    "day": 9,
    "theme": "Gratitude Letters",
    "prompt": "Write to whoever taught you how to be alone without being lonely.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 69,
    "month": "March",
    "day": 10,
    "theme": "Gratitude Letters",
    "prompt": "Thank a sibling for something only the two of you would remember.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 70,
    "month": "March",
    "day": 11,
    "theme": "Gratitude Letters",
    "prompt": "Write to someone who corrected you gently instead of publicly.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 71,
    "month": "March",
    "day": 12,
    "theme": "Gratitude Letters",
    "prompt": "Thank the person who introduced you to a book, song, or idea that rearranged you.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 72,
    "month": "March",
    "day": 13,
    "theme": "Gratitude Letters",
    "prompt": "Write to a doctor, nurse, or healer who treated you like a person, not a chart.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 73,
    "month": "March",
    "day": 14,
    "theme": "Gratitude Letters",
    "prompt": "Thank someone for the apology they never had to give but gave anyway.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 74,
    "month": "March",
    "day": 15,
    "theme": "Gratitude Letters",
    "prompt": "Write to the friend who answers the phone at the wrong hour without complaint.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 75,
    "month": "March",
    "day": 16,
    "theme": "Gratitude Letters",
    "prompt": "Thank whoever taught you to cook, fix, build, or grow something with your hands.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 76,
    "month": "March",
    "day": 17,
    "theme": "Gratitude Letters",
    "prompt": "Write to a former coworker or boss who made an unbearable job bearable.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 77,
    "month": "March",
    "day": 18,
    "theme": "Gratitude Letters",
    "prompt": "Thank the person who told you a hard truth you needed and didn't want.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 78,
    "month": "March",
    "day": 19,
    "theme": "Gratitude Letters",
    "prompt": "Write to someone who showed up to something small that mattered only to you.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 79,
    "month": "March",
    "day": 20,
    "theme": "Gratitude Letters",
    "prompt": "Thank a grandparent, or someone who stood in for one, for a piece of family history they kept alive.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 80,
    "month": "March",
    "day": 21,
    "theme": "Gratitude Letters",
    "prompt": "Write to whoever taught you what a healthy relationship actually looks like, by example.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 81,
    "month": "March",
    "day": 22,
    "theme": "Gratitude Letters",
    "prompt": "Thank a friend for laughing with you so hard about something that, on paper, wasn't even that funny.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 82,
    "month": "March",
    "day": 23,
    "theme": "Gratitude Letters",
    "prompt": "Write to someone who let you fail in front of them without flinching.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 83,
    "month": "March",
    "day": 24,
    "theme": "Gratitude Letters",
    "prompt": "Thank the person who held your secret and never once made you regret telling them.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 84,
    "month": "March",
    "day": 25,
    "theme": "Gratitude Letters",
    "prompt": "Write to a neighbor, mail carrier, or someone in your daily orbit you've never properly thanked.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 85,
    "month": "March",
    "day": 26,
    "theme": "Gratitude Letters",
    "prompt": "Thank whoever first told you that you were a good writer, even if you didn't believe them.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 86,
    "month": "March",
    "day": 27,
    "theme": "Gratitude Letters",
    "prompt": "Write to someone who taught you patience by needing yours.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 87,
    "month": "March",
    "day": 28,
    "theme": "Gratitude Letters",
    "prompt": "Thank a friend for the version of you that only exists around them.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 88,
    "month": "March",
    "day": 29,
    "theme": "Gratitude Letters",
    "prompt": "Write to the person who picked you up \u2014 literally or otherwise \u2014 at your lowest point.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 89,
    "month": "March",
    "day": 30,
    "theme": "Gratitude Letters",
    "prompt": "Thank someone for staying curious about you long after the easy questions ran out.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 90,
    "month": "March",
    "day": 31,
    "theme": "Gratitude Letters",
    "prompt": "Write the gratitude letter you've been meaning to write for years. Stop putting it off today.",
    "approach": "Thank the person for the specific thing, not the general impression. \"Thank you for being you\" says less than naming the exact moment.",
    "starters": [
      "I don't think I've ever told you",
      "I still think about when you",
      "Because of you, I"
    ],
    "tip": "Describe the moment in enough detail that they can place it \u2014 when it was, where you were, what was said.",
    "letter": {
      "author": "Vincent van Gogh",
      "recipient": "His brother, Theo van Gogh",
      "year": "1880s",
      "context": "Vincent wrote to his younger brother Theo more than 650 times over their lives. Theo, an art dealer, funded Vincent's painting for years with no expectation of repayment. Vincent's letters return again and again to what that support meant to him.",
      "excerpt": "\u201cI am still far from being what I want to be, but with God's help I shall succeed... You have done so much for me, Theo, that I can hardly find the words to thank you.\u201d",
      "tieBack": "Without Theo's letters and money, much of Vincent's work might never have been made. Gratitude, said plainly, kept a whole body of work alive."
    },
    "tier": "basic"
  },
  {
    "card": 91,
    "month": "April",
    "day": 1,
    "theme": "Encouragement",
    "prompt": "Write to a friend who is in the middle of something hard, and tell them exactly what you see them doing right.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 92,
    "month": "April",
    "day": 2,
    "theme": "Encouragement",
    "prompt": "Encourage someone who is about to quit something you know they shouldn't quit yet.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 93,
    "month": "April",
    "day": 3,
    "theme": "Encouragement",
    "prompt": "Write to someone starting over \u2014 a new city, job, or chapter \u2014 and tell them what starting over taught you.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 94,
    "month": "April",
    "day": 4,
    "theme": "Encouragement",
    "prompt": "Tell a friend going through grief that there is no timeline, and you're not watching the clock either.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 95,
    "month": "April",
    "day": 5,
    "theme": "Encouragement",
    "prompt": "Write to someone afraid to try something publicly. Remind them who you knew before they were good at it.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 96,
    "month": "April",
    "day": 6,
    "theme": "Encouragement",
    "prompt": "Encourage a friend facing a diagnosis, recovery, or treatment with specifics, not platitudes.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 97,
    "month": "April",
    "day": 7,
    "theme": "Encouragement",
    "prompt": "Write to someone doubting a decision they already made. Remind them why they made it.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 98,
    "month": "April",
    "day": 8,
    "theme": "Encouragement",
    "prompt": "Tell a friend in a creative dry spell that the work doesn't stop being theirs just because it's slow right now.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 99,
    "month": "April",
    "day": 9,
    "theme": "Encouragement",
    "prompt": "Write to someone parenting through exhaustion. Tell them what you actually notice they're doing well.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 100,
    "month": "April",
    "day": 10,
    "theme": "Encouragement",
    "prompt": "Encourage a friend rebuilding after a breakup, layoff, or loss of any kind.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 101,
    "month": "April",
    "day": 11,
    "theme": "Encouragement",
    "prompt": "Write to someone studying for something enormous. Remind them what they already know how to do.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 102,
    "month": "April",
    "day": 12,
    "theme": "Encouragement",
    "prompt": "Tell a friend who feels behind their peers that you don't experience them that way at all.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 103,
    "month": "April",
    "day": 13,
    "theme": "Encouragement",
    "prompt": "Write to someone in the hard middle of a long project, far from the finish, asking only for patience.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 104,
    "month": "April",
    "day": 14,
    "theme": "Encouragement",
    "prompt": "Encourage a friend who is scared of a conversation they need to have. Tell them what you believe they're capable of saying.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 105,
    "month": "April",
    "day": 15,
    "theme": "Encouragement",
    "prompt": "Write to someone returning to work, school, or life after time away, however that time happened.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 106,
    "month": "April",
    "day": 16,
    "theme": "Encouragement",
    "prompt": "Tell a friend battling self-doubt one specific way you've seen them prove it wrong before.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 107,
    "month": "April",
    "day": 17,
    "theme": "Encouragement",
    "prompt": "Write to someone caring for a sick or aging parent. Acknowledge the part of it nobody else sees.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 108,
    "month": "April",
    "day": 18,
    "theme": "Encouragement",
    "prompt": "Encourage a friend who just got rejected from something they wanted badly.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 109,
    "month": "April",
    "day": 19,
    "theme": "Encouragement",
    "prompt": "Write to someone moving through a hard year quietly, without asking for help. Offer it anyway.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 110,
    "month": "April",
    "day": 20,
    "theme": "Encouragement",
    "prompt": "Tell a friend learning a new skill late that \"late\" is a story, not a fact.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 111,
    "month": "April",
    "day": 21,
    "theme": "Encouragement",
    "prompt": "Write to someone facing a fear they've been avoiding for years. Walk with them toward it, on paper.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 112,
    "month": "April",
    "day": 22,
    "theme": "Encouragement",
    "prompt": "Encourage a friend whose confidence took a hit recently. Remind them what hasn't changed about them.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 113,
    "month": "April",
    "day": 23,
    "theme": "Encouragement",
    "prompt": "Write to someone in the hardest stretch of becoming sober, healthier, or different than they were.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 114,
    "month": "April",
    "day": 24,
    "theme": "Encouragement",
    "prompt": "Tell a friend mid-divorce or separation that this chapter does not define the whole book.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 115,
    "month": "April",
    "day": 25,
    "theme": "Encouragement",
    "prompt": "Write to someone who just became a parent, sibling, or caretaker for the first time.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 116,
    "month": "April",
    "day": 26,
    "theme": "Encouragement",
    "prompt": "Encourage a friend whose business, project, or dream is struggling. Remind them why they started.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 117,
    "month": "April",
    "day": 27,
    "theme": "Encouragement",
    "prompt": "Write to someone grieving a future they thought they'd have. Don't rush them past it.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 118,
    "month": "April",
    "day": 28,
    "theme": "Encouragement",
    "prompt": "Tell a friend who feels invisible at work or home one specific thing you'd miss if they were gone.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 119,
    "month": "April",
    "day": 29,
    "theme": "Encouragement",
    "prompt": "Write to someone facing a hard medical week. Tell them what you'll be doing while you wait with them.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 120,
    "month": "April",
    "day": 30,
    "theme": "Encouragement",
    "prompt": "Write the encouragement letter you wish someone had sent you during your hardest year. Send it to someone living it now.",
    "approach": "Encouragement lands best as evidence, not cheerleading. Tell them what you've actually seen them do, not just what you believe about them.",
    "starters": [
      "I see you doing",
      "You don't give yourself credit for",
      "Whatever happens next, remember"
    ],
    "tip": "Avoid \"everything will be fine.\" Say something true and specific instead.",
    "letter": {
      "author": "Abigail Adams",
      "recipient": "Her son, John Quincy Adams (age 13)",
      "year": "January 1780",
      "context": "Abigail Adams sent her teenage son across the Atlantic with his father during the Revolutionary War. Writing to encourage him through the hardship and danger of the voyage and the unsettled years ahead, she offered one of the era's most quoted lines on resilience.",
      "excerpt": "\u201cThese are times in which a genius would wish to live. It is not in the still calm of life, or in the repose of a pacific station, that great characters are formed... Great necessities call out great virtues.\u201d",
      "tieBack": "Abigail didn't promise her son an easy passage \u2014 she told him what the hard one was for. Real encouragement often does the same."
    },
    "tier": "basic"
  },
  {
    "card": 121,
    "month": "May",
    "day": 1,
    "theme": "Mothers & Mentors",
    "prompt": "Write to your mother, or the woman who raised you, about a lesson she never said out loud but taught you anyway.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 122,
    "month": "May",
    "day": 2,
    "theme": "Mothers & Mentors",
    "prompt": "Thank a mentor for correcting a habit that was quietly limiting you.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 123,
    "month": "May",
    "day": 3,
    "theme": "Mothers & Mentors",
    "prompt": "Write to your mother about a moment you understood her differently once you were older.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 124,
    "month": "May",
    "day": 4,
    "theme": "Mothers & Mentors",
    "prompt": "Tell a mentor what you stole from them \u2014 a phrase, a habit, a way of seeing things \u2014 and still use.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 125,
    "month": "May",
    "day": 5,
    "theme": "Mothers & Mentors",
    "prompt": "Write to the woman who mothered you without being asked to.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 126,
    "month": "May",
    "day": 6,
    "theme": "Mothers & Mentors",
    "prompt": "Thank a teacher who saw something in you before report cards did.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 127,
    "month": "May",
    "day": 7,
    "theme": "Mothers & Mentors",
    "prompt": "Write to your mother about the smell, sound, or meal that brings her kitchen back instantly.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 128,
    "month": "May",
    "day": 8,
    "theme": "Mothers & Mentors",
    "prompt": "Tell a mentor about a piece of advice you ignored at the time and now live by.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 129,
    "month": "May",
    "day": 9,
    "theme": "Mothers & Mentors",
    "prompt": "Write to a grandmother, or someone who filled that role, about a story she told you more than once.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 130,
    "month": "May",
    "day": 10,
    "theme": "Mothers & Mentors",
    "prompt": "Thank the coach, instructor, or guide who pushed you past where you would have stopped alone.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 131,
    "month": "May",
    "day": 11,
    "theme": "Mothers & Mentors",
    "prompt": "Write to your mother about something you now understand she sacrificed without naming it.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 132,
    "month": "May",
    "day": 12,
    "theme": "Mothers & Mentors",
    "prompt": "Tell a mentor the specific moment you realized you were starting to think like them.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 133,
    "month": "May",
    "day": 13,
    "theme": "Mothers & Mentors",
    "prompt": "Write to the first boss who treated you like you already belonged in the room.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 134,
    "month": "May",
    "day": 14,
    "theme": "Mothers & Mentors",
    "prompt": "Thank a mother figure for the rules you resented then and are grateful for now.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 135,
    "month": "May",
    "day": 15,
    "theme": "Mothers & Mentors",
    "prompt": "Write to a mentor who is no longer in your life day-to-day. Tell them what they're missing of yours.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 136,
    "month": "May",
    "day": 16,
    "theme": "Mothers & Mentors",
    "prompt": "Tell your mother one thing you hope to do the same way she did, and one thing you hope to do differently.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 137,
    "month": "May",
    "day": 17,
    "theme": "Mothers & Mentors",
    "prompt": "Write to the older woman in your life \u2014 aunt, neighbor, family friend \u2014 who quietly modeled a kind of strength.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 138,
    "month": "May",
    "day": 18,
    "theme": "Mothers & Mentors",
    "prompt": "Thank a mentor for believing your potential was bigger than your current performance.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 139,
    "month": "May",
    "day": 19,
    "theme": "Mothers & Mentors",
    "prompt": "Write to your mother about a fear she passed down to you, gently, without intending to.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 140,
    "month": "May",
    "day": 20,
    "theme": "Mothers & Mentors",
    "prompt": "Tell a teacher or guide the long-term effect of one short conversation you had with them.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 141,
    "month": "May",
    "day": 21,
    "theme": "Mothers & Mentors",
    "prompt": "Write to a mother figure about the inheritance she gave you that has nothing to do with money.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 142,
    "month": "May",
    "day": 22,
    "theme": "Mothers & Mentors",
    "prompt": "Thank a mentor for telling you something you weren't ready to hear at the time.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 143,
    "month": "May",
    "day": 23,
    "theme": "Mothers & Mentors",
    "prompt": "Write to your mother about motherhood itself \u2014 what you've learned watching her, whether or not you are one.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 144,
    "month": "May",
    "day": 24,
    "theme": "Mothers & Mentors",
    "prompt": "Tell a mentor what you would have done differently without their example.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 145,
    "month": "May",
    "day": 25,
    "theme": "Mothers & Mentors",
    "prompt": "Write to a woman who mentored you professionally about the door she opened that you walked through.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 146,
    "month": "May",
    "day": 26,
    "theme": "Mothers & Mentors",
    "prompt": "Thank your mother for a single ordinary Tuesday you remember for no obvious reason.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 147,
    "month": "May",
    "day": 27,
    "theme": "Mothers & Mentors",
    "prompt": "Write to the person who taught you how to handle failure by showing you their own.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 148,
    "month": "May",
    "day": 28,
    "theme": "Mothers & Mentors",
    "prompt": "Tell a mentor what you now teach others that you first learned from them.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 149,
    "month": "May",
    "day": 29,
    "theme": "Mothers & Mentors",
    "prompt": "Write to your mother about the parts of her you see in yourself, the good and the complicated.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 150,
    "month": "May",
    "day": 30,
    "theme": "Mothers & Mentors",
    "prompt": "Thank a guide or elder for patience they extended you long after you deserved it.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 151,
    "month": "May",
    "day": 31,
    "theme": "Mothers & Mentors",
    "prompt": "Write the letter to a mother or mentor you've been delaying because it feels too big to say out loud. Say it anyway.",
    "approach": "Name the lesson you only understood later. Mentors rarely know which moment mattered most until someone tells them.",
    "starters": [
      "I didn't understand it then, but",
      "Something you taught me without meaning to",
      "I still do this because of you:"
    ],
    "tip": "If they're no longer reachable, write it anyway \u2014 to them, or to whoever carries their memory now.",
    "letter": {
      "author": "Philip Dormer Stanhope, Earl of Chesterfield",
      "recipient": "His son, Philip Stanhope",
      "year": "1740s\u20131750s",
      "context": "Over nearly thirty years, Lord Chesterfield wrote his illegitimate son hundreds of letters of worldly advice \u2014 on manners, character, and judgment \u2014 intended to prepare him for a life Chesterfield himself wouldn't be present for much longer.",
      "excerpt": "\u201cKnowledge of the world is only to be acquired in the world, not in a closet... Style is the dress of thoughts.\u201d",
      "tieBack": "Chesterfield mentored his son almost entirely on paper. A letter can carry guidance that outlasts the person who wrote it."
    },
    "tier": "basic"
  },
  {
    "card": 152,
    "month": "June",
    "day": 1,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend who lives in another time zone about your week, in the kind of detail texts never get.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 153,
    "month": "June",
    "day": 2,
    "theme": "Friends Far Away",
    "prompt": "Tell a friend overseas what your current city looks like right now, out the window, as you write.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 154,
    "month": "June",
    "day": 3,
    "theme": "Friends Far Away",
    "prompt": "Write to a childhood friend you've lost daily contact with but never lost the bond.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 155,
    "month": "June",
    "day": 4,
    "theme": "Friends Far Away",
    "prompt": "Tell a friend abroad something you'd only say in a letter, never out loud over video.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 156,
    "month": "June",
    "day": 5,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend who moved away about the empty space they left in your week.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 157,
    "month": "June",
    "day": 6,
    "theme": "Friends Far Away",
    "prompt": "Tell a long-distance friend about a meal, song, or place that reminded you of a memory you share.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 158,
    "month": "June",
    "day": 7,
    "theme": "Friends Far Away",
    "prompt": "Write to a college friend scattered to another city about who you both used to be.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 159,
    "month": "June",
    "day": 8,
    "theme": "Friends Far Away",
    "prompt": "Tell a friend far away the news you haven't gotten around to texting them yet.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 160,
    "month": "June",
    "day": 9,
    "theme": "Friends Far Away",
    "prompt": "Write to a pen pal you've never met in person about what you hope they're doing right now.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 161,
    "month": "June",
    "day": 10,
    "theme": "Friends Far Away",
    "prompt": "Tell a friend overseas about a tradition of yours they're missing this year.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 162,
    "month": "June",
    "day": 11,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend stationed, deployed, or working far from home about the ordinary things they might be missing.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 163,
    "month": "June",
    "day": 12,
    "theme": "Friends Far Away",
    "prompt": "Tell a friend in another country what's changed in your hometown since they left.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 164,
    "month": "June",
    "day": 13,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend who emigrated about what \"home\" means to each of you now.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 165,
    "month": "June",
    "day": 14,
    "theme": "Friends Far Away",
    "prompt": "Tell a far-away friend a secret you've been saving for someone who isn't in your daily orbit.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 166,
    "month": "June",
    "day": 15,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend who moved for love, work, or escape about whether it was worth it.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 167,
    "month": "June",
    "day": 16,
    "theme": "Friends Far Away",
    "prompt": "Tell a friend abroad about the last time their name came up in conversation, and why.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 168,
    "month": "June",
    "day": 17,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend you only see every few years about how you've each changed since the last visit.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 169,
    "month": "June",
    "day": 18,
    "theme": "Friends Far Away",
    "prompt": "Tell a long-distance friend what you'd do together if they were here this weekend.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 170,
    "month": "June",
    "day": 19,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend traveling somewhere remote about what you hope they notice while they're there.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 171,
    "month": "June",
    "day": 20,
    "theme": "Friends Far Away",
    "prompt": "Tell a friend far away about a fear or hope you haven't said to anyone nearby.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 172,
    "month": "June",
    "day": 21,
    "theme": "Friends Far Away",
    "prompt": "Write to an old roommate now living elsewhere about the apartment you shared and what it taught you.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 173,
    "month": "June",
    "day": 22,
    "theme": "Friends Far Away",
    "prompt": "Tell a friend overseas the joke only the two of you would understand, and why it still works.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 174,
    "month": "June",
    "day": 23,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend who left your friend group's chat behind without leaving the friendship behind.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 175,
    "month": "June",
    "day": 24,
    "theme": "Friends Far Away",
    "prompt": "Tell a far-away friend what you've kept of theirs \u2014 literally or otherwise \u2014 since they left.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 176,
    "month": "June",
    "day": 25,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend living through a different season, weather, or hour than you right now.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 177,
    "month": "June",
    "day": 26,
    "theme": "Friends Far Away",
    "prompt": "Tell a friend abroad something about your life you've been hesitant to admit, even to them.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 178,
    "month": "June",
    "day": 27,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend you met while traveling, who exists now only in letters and memory.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 179,
    "month": "June",
    "day": 28,
    "theme": "Friends Far Away",
    "prompt": "Tell a long-distance friend what you'd want them to read first if this letter is the only thing of yours they get this year.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 180,
    "month": "June",
    "day": 29,
    "theme": "Friends Far Away",
    "prompt": "Write to a friend far away about the version of \"catching up\" that actually matters to you, beyond small talk.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 181,
    "month": "June",
    "day": 30,
    "theme": "Friends Far Away",
    "prompt": "Write to the friend furthest from you right now and close the distance the only way a letter can.",
    "approach": "Letters compress distance better than texts do \u2014 write the way you'd talk if you had an unhurried afternoon together.",
    "starters": [
      "If you were here right now,",
      "I keep meaning to tell you,",
      "This made me think of you:"
    ],
    "tip": "Include something from your actual day \u2014 letters are a record of presence, not just feeling.",
    "letter": {
      "author": "Mark Twain",
      "recipient": "His childhood friend, Will Bowen",
      "year": "1870",
      "context": "Decades after leaving Hannibal, Missouri, Mark Twain wrote to Will Bowen, the friend he'd once roamed the riverbanks with as a boy. By then both men were grown, scattered, and decades removed from the town that shaped them \u2014 but the letter found its way back there anyway.",
      "excerpt": "Twain wrote that the memory of those Hannibal days came back to him \u201clike a panorama\u201d \u2014 every raft, cave, and stolen afternoon as vivid as the day it happened.",
      "tieBack": "Distance didn't dull the memory \u2014 if anything, it sharpened it. A letter to a far-away friend can do the same for both of you."
    },
    "tier": "basic"
  },
  {
    "card": 182,
    "month": "July",
    "day": 1,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone you owe a quiet apology to, even if you never find the courage to send it.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 183,
    "month": "July",
    "day": 2,
    "theme": "Letters Never Sent",
    "prompt": "Write to the person you had to walk away from in order to keep growing.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 184,
    "month": "July",
    "day": 3,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone you loved once, saying the thing you never said before it ended.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 185,
    "month": "July",
    "day": 4,
    "theme": "Letters Never Sent",
    "prompt": "Write to a person who hurt you, not to forgive them yet, just to say exactly what happened.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 186,
    "month": "July",
    "day": 5,
    "theme": "Letters Never Sent",
    "prompt": "Write to a friend you lost touch with by accident, then let stay lost on purpose.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 187,
    "month": "July",
    "day": 6,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone you're still angry at, and let the letter be as unfair as the anger actually is.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 188,
    "month": "July",
    "day": 7,
    "theme": "Letters Never Sent",
    "prompt": "Write the letter you wanted to hand someone at their funeral but couldn't find the words for in time.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 189,
    "month": "July",
    "day": 8,
    "theme": "Letters Never Sent",
    "prompt": "Write to an ex about the version of the relationship only you remember.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 190,
    "month": "July",
    "day": 9,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone who left without explanation. Ask the question you never got to ask.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 191,
    "month": "July",
    "day": 10,
    "theme": "Letters Never Sent",
    "prompt": "Write to a parent about the conversation you've rehearsed for years and never started.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 192,
    "month": "July",
    "day": 11,
    "theme": "Letters Never Sent",
    "prompt": "Write to the person you ghosted, or who ghosted you, and finish the sentence either way.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 193,
    "month": "July",
    "day": 12,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone you betrayed, even in a small way, and admit it plainly.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 194,
    "month": "July",
    "day": 13,
    "theme": "Letters Never Sent",
    "prompt": "Write to a friend who chose someone else's side. Tell them what that choice cost you.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 195,
    "month": "July",
    "day": 14,
    "theme": "Letters Never Sent",
    "prompt": "Write to a former boss or colleague exactly what you wanted to say on your last day.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 196,
    "month": "July",
    "day": 15,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone you're jealous of. Say the ugly, honest thing, then say what's underneath it.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 197,
    "month": "July",
    "day": 16,
    "theme": "Letters Never Sent",
    "prompt": "Write to a person from your past you've built an entire imaginary argument with in the shower.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 198,
    "month": "July",
    "day": 17,
    "theme": "Letters Never Sent",
    "prompt": "Write to the person who broke your trust about what trust used to feel like before them.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 199,
    "month": "July",
    "day": 18,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone you miss but know you shouldn't reach out to. Let the letter be the reaching out.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 200,
    "month": "July",
    "day": 19,
    "theme": "Letters Never Sent",
    "prompt": "Write to a sibling about the rivalry, debt, or silence neither of you started but both of you kept.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 201,
    "month": "July",
    "day": 20,
    "theme": "Letters Never Sent",
    "prompt": "Write to a former friend about the moment the friendship actually ended, even if neither of you marked it.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 202,
    "month": "July",
    "day": 21,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone you wronged in a way they may not even know about. Confess it here first.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 203,
    "month": "July",
    "day": 22,
    "theme": "Letters Never Sent",
    "prompt": "Write to a person you loved long-distance who chose distance over you.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 204,
    "month": "July",
    "day": 23,
    "theme": "Letters Never Sent",
    "prompt": "Write to the version of a relationship that existed only in your head, never out loud.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 205,
    "month": "July",
    "day": 24,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone who never apologized to you. Write the apology you wish they'd written instead.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 206,
    "month": "July",
    "day": 25,
    "theme": "Letters Never Sent",
    "prompt": "Write to a person from a relationship that ended badly, but say one true, generous thing about them anyway.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 207,
    "month": "July",
    "day": 26,
    "theme": "Letters Never Sent",
    "prompt": "Write to the friend you owe an explanation to for disappearing.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 208,
    "month": "July",
    "day": 27,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone you envy their ease with, and ask, on paper, what they have that you don't.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 209,
    "month": "July",
    "day": 28,
    "theme": "Letters Never Sent",
    "prompt": "Write to a person you loved and never got the chance to lose well \u2014 through death, distance, or silence.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 210,
    "month": "July",
    "day": 29,
    "theme": "Letters Never Sent",
    "prompt": "Write to yourself in the middle of an old conflict, before you knew how it would end.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 211,
    "month": "July",
    "day": 30,
    "theme": "Letters Never Sent",
    "prompt": "Write to someone you've decided not to forgive yet. Say why, without apologizing for the decision.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 212,
    "month": "July",
    "day": 31,
    "theme": "Letters Never Sent",
    "prompt": "Write the letter you've avoided all month. Don't send it. Just finally write it.",
    "approach": "This one is for you, not them. Say the unfiltered thing \u2014 you decide afterward whether it's ever sent.",
    "starters": [
      "What I never said is",
      "If I'm honest,",
      "I'm still angry that"
    ],
    "tip": "Don't soften it for an audience. The point of an unsent letter is that nobody's reading over your shoulder.",
    "letter": {
      "author": "Abraham Lincoln",
      "recipient": "Major General George Meade",
      "year": "July 14, 1863",
      "context": "After the Union victory at Gettysburg, Lincoln was furious that General Meade let Robert E. Lee's army escape across the Potomac instead of pursuing it. He drafted a sharp letter of rebuke \u2014 then never sent it. It was found among his papers after his death.",
      "excerpt": "\u201cYour golden opportunity is gone, and I am distressed immeasurably because of it... I beg you will not consider this a prosecution, or persecution of yourself.\u201d",
      "tieBack": "Lincoln wrote down exactly what he needed to say \u2014 and then decided saying it wouldn't help anyone. Some letters do their work just by being written."
    },
    "tier": "full"
  },
  {
    "card": 213,
    "month": "August",
    "day": 1,
    "theme": "Younger Self",
    "prompt": "Write to yourself at seven years old about what you got right that you've since talked yourself out of.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 214,
    "month": "August",
    "day": 2,
    "theme": "Younger Self",
    "prompt": "Write to your teenage self about the thing you were so sure would never get better.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 215,
    "month": "August",
    "day": 3,
    "theme": "Younger Self",
    "prompt": "Write to yourself on your first day at a school, job, or city that scared you.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 216,
    "month": "August",
    "day": 4,
    "theme": "Younger Self",
    "prompt": "Write to the version of you that believed something untrue about your own worth, and correct it gently.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 217,
    "month": "August",
    "day": 5,
    "theme": "Younger Self",
    "prompt": "Write to yourself the year you experienced your first real heartbreak.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 218,
    "month": "August",
    "day": 6,
    "theme": "Younger Self",
    "prompt": "Write to your younger self about a friendship that ended before either of you knew how to keep it.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 219,
    "month": "August",
    "day": 7,
    "theme": "Younger Self",
    "prompt": "Write to yourself the year a parent or sibling let you down, and tell them what you understand now.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 220,
    "month": "August",
    "day": 8,
    "theme": "Younger Self",
    "prompt": "Write to the kid who loved something everyone else thought was uncool. Tell them to keep loving it.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 221,
    "month": "August",
    "day": 9,
    "theme": "Younger Self",
    "prompt": "Write to yourself in the year you stopped doing something you loved. Ask why, gently.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 222,
    "month": "August",
    "day": 10,
    "theme": "Younger Self",
    "prompt": "Write to the version of you that took a risk nobody supported. Tell them how it actually turned out.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 223,
    "month": "August",
    "day": 11,
    "theme": "Younger Self",
    "prompt": "Write to yourself the year you were bullied, excluded, or made small. Tell them what you'd do differently now, and what wasn't their fault.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 224,
    "month": "August",
    "day": 12,
    "theme": "Younger Self",
    "prompt": "Write to your younger self about a body image struggle, and what you wish someone had told you instead.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 225,
    "month": "August",
    "day": 13,
    "theme": "Younger Self",
    "prompt": "Write to yourself the year you made a mistake you still think about. Offer the forgiveness you never gave yourself.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 226,
    "month": "August",
    "day": 14,
    "theme": "Younger Self",
    "prompt": "Write to the version of you who didn't yet know what you wanted to do with your life. Tell them it's allowed to take longer.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 227,
    "month": "August",
    "day": 15,
    "theme": "Younger Self",
    "prompt": "Write to yourself the year your parents' relationship changed \u2014 through divorce, distance, or simply growing apart.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 228,
    "month": "August",
    "day": 16,
    "theme": "Younger Self",
    "prompt": "Write to the kid who was the funniest, quietest, angriest, or most invisible one in the room. Tell them what you see now.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 229,
    "month": "August",
    "day": 17,
    "theme": "Younger Self",
    "prompt": "Write to yourself the year you first moved away from home.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 230,
    "month": "August",
    "day": 18,
    "theme": "Younger Self",
    "prompt": "Write to your younger self about a dream you let go of. Tell them whether you miss it.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 231,
    "month": "August",
    "day": 19,
    "theme": "Younger Self",
    "prompt": "Write to the version of you that didn't have the words yet for something you now understand clearly.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 232,
    "month": "August",
    "day": 20,
    "theme": "Younger Self",
    "prompt": "Write to yourself the year you first learned what grief was.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 233,
    "month": "August",
    "day": 21,
    "theme": "Younger Self",
    "prompt": "Write to your younger self about the friend group you outgrew, and what you took with you when you left.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 234,
    "month": "August",
    "day": 22,
    "theme": "Younger Self",
    "prompt": "Write to the version of you who was certain about something you've since completely changed your mind on.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 235,
    "month": "August",
    "day": 23,
    "theme": "Younger Self",
    "prompt": "Write to yourself the year you first felt like an adult, even if no one else treated you like one yet.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 236,
    "month": "August",
    "day": 24,
    "theme": "Younger Self",
    "prompt": "Write to the kid version of you about money \u2014 what you believed about it, and what's actually true.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 237,
    "month": "August",
    "day": 25,
    "theme": "Younger Self",
    "prompt": "Write to your younger self about a teacher, coach, or adult who got something badly wrong.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 238,
    "month": "August",
    "day": 26,
    "theme": "Younger Self",
    "prompt": "Write to yourself the year you fell in love for the first time. Tell them what survived and what didn't.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 239,
    "month": "August",
    "day": 27,
    "theme": "Younger Self",
    "prompt": "Write to the version of you that apologized too much, or not enough, and explain the difference now.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 240,
    "month": "August",
    "day": 28,
    "theme": "Younger Self",
    "prompt": "Write to your younger self about the family secret, spoken or unspoken, that shaped more than you realized.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 241,
    "month": "August",
    "day": 29,
    "theme": "Younger Self",
    "prompt": "Write to yourself the year you first disappointed someone you admired. Tell them how you recovered.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 242,
    "month": "August",
    "day": 30,
    "theme": "Younger Self",
    "prompt": "Write to the version of you who thought adulthood would feel different than it does.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 243,
    "month": "August",
    "day": 31,
    "theme": "Younger Self",
    "prompt": "Write the letter your younger self most needed to receive. Mail it to yourself, today, as proof someone finally wrote it.",
    "approach": "Write to them like a kind older sibling, not a disappointed parent. They did the best they could with what they knew.",
    "starters": [
      "You don't know this yet, but",
      "I wish someone had told you",
      "You were right about"
    ],
    "tip": "Resist the urge to just give advice \u2014 tell them what you understand now that you didn't then.",
    "letter": {
      "author": "John Keats",
      "recipient": "His younger sister, Fanny Keats",
      "year": "1818\u20131820",
      "context": "Keats was orphaned young and largely raised apart from his much younger sister Fanny. His letters to her are tender and protective, often looking back on their scattered childhood and trying, on paper, to be the steady presence circumstances hadn't allowed him to be in person.",
      "excerpt": "He wrote to her of wanting to \u201cbe of some service\u201d to her in a world that had given them so little family stability \u2014 a grown man writing gently back toward the child he'd once shared a home with.",
      "tieBack": "Keats couldn't go back and be present for Fanny's whole childhood. He could only write to her from where he stood. That's often all any of us can do."
    },
    "tier": "full"
  },
  {
    "card": 244,
    "month": "September",
    "day": 1,
    "theme": "Forgiveness",
    "prompt": "Write to someone you need to forgive, even if you're not ready to send it or mean it yet.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 245,
    "month": "September",
    "day": 2,
    "theme": "Forgiveness",
    "prompt": "Write to yourself about a mistake you've been punishing yourself for longer than it deserves.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 246,
    "month": "September",
    "day": 3,
    "theme": "Forgiveness",
    "prompt": "Write to a parent you're working on forgiving, naming exactly what happened, without softening it.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 247,
    "month": "September",
    "day": 4,
    "theme": "Forgiveness",
    "prompt": "Write to a friend who let you down once. Decide, on paper, whether this is the letter that forgives them.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 248,
    "month": "September",
    "day": 5,
    "theme": "Forgiveness",
    "prompt": "Write to someone who never apologized. Forgive them anyway, and say why you're choosing to.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 249,
    "month": "September",
    "day": 6,
    "theme": "Forgiveness",
    "prompt": "Write to your body about the ways you've been unkind to it, and ask its forgiveness.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 250,
    "month": "September",
    "day": 7,
    "theme": "Forgiveness",
    "prompt": "Write to a sibling about an old resentment. Try to set down at least part of its weight.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 251,
    "month": "September",
    "day": 8,
    "theme": "Forgiveness",
    "prompt": "Write to an ex-partner who hurt you. Separate the forgiveness from the reconciliation \u2014 you can offer one without the other.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 252,
    "month": "September",
    "day": 9,
    "theme": "Forgiveness",
    "prompt": "Write to yourself about the version of you that made the choice you regret most.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 253,
    "month": "September",
    "day": 10,
    "theme": "Forgiveness",
    "prompt": "Write to someone who forgave you once, and tell them what that forgiveness actually did for you.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 254,
    "month": "September",
    "day": 11,
    "theme": "Forgiveness",
    "prompt": "Write to a friend about a falling-out neither of you ever properly addressed.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 255,
    "month": "September",
    "day": 12,
    "theme": "Forgiveness",
    "prompt": "Write to a parent or guardian about forgiving them for being human instead of perfect.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 256,
    "month": "September",
    "day": 13,
    "theme": "Forgiveness",
    "prompt": "Write to yourself about a grudge you've outgrown but never formally let go of.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 257,
    "month": "September",
    "day": 14,
    "theme": "Forgiveness",
    "prompt": "Write to someone who hurt someone you love. Decide what, if anything, you're willing to forgive on their behalf.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 258,
    "month": "September",
    "day": 15,
    "theme": "Forgiveness",
    "prompt": "Write to a former friend who betrayed a confidence. Say what trust would take to rebuild, even if you're not offering it.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 259,
    "month": "September",
    "day": 16,
    "theme": "Forgiveness",
    "prompt": "Write to yourself about forgiving a younger version of you for not knowing better.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 260,
    "month": "September",
    "day": 17,
    "theme": "Forgiveness",
    "prompt": "Write to a teacher, coach, or authority figure who was unfair to you as a child.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 261,
    "month": "September",
    "day": 18,
    "theme": "Forgiveness",
    "prompt": "Write to someone you forgave too quickly. Tell them what you wish you'd said first.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 262,
    "month": "September",
    "day": 19,
    "theme": "Forgiveness",
    "prompt": "Write to a friend about forgiving the distance, not just the disagreement, that grew between you.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 263,
    "month": "September",
    "day": 20,
    "theme": "Forgiveness",
    "prompt": "Write to yourself about forgiving a year that didn't go the way you needed it to.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 264,
    "month": "September",
    "day": 21,
    "theme": "Forgiveness",
    "prompt": "Write to a family member about an old debt \u2014 financial or emotional \u2014 you're ready to consider closed.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 265,
    "month": "September",
    "day": 22,
    "theme": "Forgiveness",
    "prompt": "Write to someone who never asked for forgiveness but clearly needs it. Offer it as a gift, not an obligation.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 266,
    "month": "September",
    "day": 23,
    "theme": "Forgiveness",
    "prompt": "Write to your past self about forgiving a relationship you stayed in too long.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 267,
    "month": "September",
    "day": 24,
    "theme": "Forgiveness",
    "prompt": "Write to a friend who said something cruel once. Decide what part of that moment you're still carrying.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 268,
    "month": "September",
    "day": 25,
    "theme": "Forgiveness",
    "prompt": "Write to yourself about forgiving your own ambition, or lack of it, this year.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 269,
    "month": "September",
    "day": 26,
    "theme": "Forgiveness",
    "prompt": "Write to a parent about forgiving the childhood you had instead of the one you wished for.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 270,
    "month": "September",
    "day": 27,
    "theme": "Forgiveness",
    "prompt": "Write to someone you've decided to stop being angry at, even if the relationship is over for good.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 271,
    "month": "September",
    "day": 28,
    "theme": "Forgiveness",
    "prompt": "Write to yourself about a forgiveness you've given everyone except you.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 272,
    "month": "September",
    "day": 29,
    "theme": "Forgiveness",
    "prompt": "Write to a friend about reconciling \u2014 not forgetting, just choosing to move forward together.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 273,
    "month": "September",
    "day": 30,
    "theme": "Forgiveness",
    "prompt": "Write the letter that finally sets one specific grudge down. Notice how much lighter the page feels than the grudge did.",
    "approach": "Forgiving isn't the same as saying it was fine. Name what happened honestly, then decide what you're setting down.",
    "starters": [
      "What happened was",
      "I've carried this for a long time:",
      "I'm ready to stop"
    ],
    "tip": "You can write this letter whether or not the other person ever sees it \u2014 the release is often the point.",
    "letter": {
      "author": "Frederick Douglass",
      "recipient": "Thomas Auld, his former enslaver",
      "year": "September 3, 1848",
      "context": "On the tenth anniversary of his escape from slavery, Douglass published an open letter directly addressed to the man who had once enslaved him \u2014 confronting the past plainly, without asking permission to do so, and without pretending the wrong hadn't happened.",
      "excerpt": "\u201cI am your fellow-man, but not your slave... I will not censure you. I leave you to the inevitable consequences of your own actions.\u201d",
      "tieBack": "Douglass's letter doesn't pretend the harm didn't happen. It says the true thing, plainly, and then sets the weight of it down."
    },
    "tier": "full"
  },
  {
    "card": 274,
    "month": "October",
    "day": 1,
    "theme": "Appreciation",
    "prompt": "Write to someone who does a quiet, unglamorous job that makes your life easier and tell them you noticed.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 275,
    "month": "October",
    "day": 2,
    "theme": "Appreciation",
    "prompt": "Write to a friend and list, specifically, five things about them you appreciate and never say out loud.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 276,
    "month": "October",
    "day": 3,
    "theme": "Appreciation",
    "prompt": "Write to a colleague about a piece of work they did that you genuinely admired.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 277,
    "month": "October",
    "day": 4,
    "theme": "Appreciation",
    "prompt": "Write to someone who consistently shows up on time, follows through, or keeps their word \u2014 and tell them it matters.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 278,
    "month": "October",
    "day": 5,
    "theme": "Appreciation",
    "prompt": "Write to a friend's partner, thanking them for how they treat someone you love.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 279,
    "month": "October",
    "day": 6,
    "theme": "Appreciation",
    "prompt": "Write to a community member \u2014 a barista, librarian, mail carrier \u2014 whose presence makes your routine warmer.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 280,
    "month": "October",
    "day": 7,
    "theme": "Appreciation",
    "prompt": "Write to someone who listens well, and tell them exactly what that has meant to you.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 281,
    "month": "October",
    "day": 8,
    "theme": "Appreciation",
    "prompt": "Write to a friend's child about something wonderful you've noticed in them.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 282,
    "month": "October",
    "day": 9,
    "theme": "Appreciation",
    "prompt": "Write to a person who does volunteer or unpaid work that goes unnoticed, and notice it.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 283,
    "month": "October",
    "day": 10,
    "theme": "Appreciation",
    "prompt": "Write to someone whose humor has gotten you through more than they probably realize.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 284,
    "month": "October",
    "day": 11,
    "theme": "Appreciation",
    "prompt": "Write to a partner or roommate, appreciating one mundane chore they always quietly handle.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 285,
    "month": "October",
    "day": 12,
    "theme": "Appreciation",
    "prompt": "Write to a friend who remembers small details about your life that you never expected them to keep track of.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 286,
    "month": "October",
    "day": 13,
    "theme": "Appreciation",
    "prompt": "Write to someone who has stayed consistent \u2014 in mood, in friendship, in presence \u2014 through years of change.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 287,
    "month": "October",
    "day": 14,
    "theme": "Appreciation",
    "prompt": "Write to a person who taught you something practical: how to drive, budget, cook, or fix something.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 288,
    "month": "October",
    "day": 15,
    "theme": "Appreciation",
    "prompt": "Write to a friend's parent who welcomed you like family.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 289,
    "month": "October",
    "day": 16,
    "theme": "Appreciation",
    "prompt": "Write to someone whose taste \u2014 in books, music, or food \u2014 has shaped your own without you noticing until now.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 290,
    "month": "October",
    "day": 17,
    "theme": "Appreciation",
    "prompt": "Write to a coworker who makes a hard workplace easier to bear.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 291,
    "month": "October",
    "day": 18,
    "theme": "Appreciation",
    "prompt": "Write to someone who gives good advice only when asked, and never when it isn't.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 292,
    "month": "October",
    "day": 19,
    "theme": "Appreciation",
    "prompt": "Write to a friend who is reliably, unfashionably kind, and tell them it isn't unnoticed.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 293,
    "month": "October",
    "day": 20,
    "theme": "Appreciation",
    "prompt": "Write to someone whose presence at gatherings makes the whole room better, and tell them how.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 294,
    "month": "October",
    "day": 21,
    "theme": "Appreciation",
    "prompt": "Write to a person who has quietly mentored your child, niece, nephew, or younger relative.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 295,
    "month": "October",
    "day": 22,
    "theme": "Appreciation",
    "prompt": "Write to a friend who tells you the truth even when a kinder lie would be easier for them.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 296,
    "month": "October",
    "day": 23,
    "theme": "Appreciation",
    "prompt": "Write to someone whose work ethic has quietly inspired your own.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 297,
    "month": "October",
    "day": 24,
    "theme": "Appreciation",
    "prompt": "Write to a person who makes you laugh at yourself in a way that always helps, never stings.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 298,
    "month": "October",
    "day": 25,
    "theme": "Appreciation",
    "prompt": "Write to someone who is good at celebrating other people's wins without making it about themselves.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 299,
    "month": "October",
    "day": 26,
    "theme": "Appreciation",
    "prompt": "Write to a friend who has never once made you feel like a burden, even when you were certain you were one.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 300,
    "month": "October",
    "day": 27,
    "theme": "Appreciation",
    "prompt": "Write to someone whose patience with a difficult family member, situation, or season you've quietly admired.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 301,
    "month": "October",
    "day": 28,
    "theme": "Appreciation",
    "prompt": "Write to a person who gives generously without ever mentioning it again.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 302,
    "month": "October",
    "day": 29,
    "theme": "Appreciation",
    "prompt": "Write to someone who has become a steady, unremarkable, essential part of your week.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 303,
    "month": "October",
    "day": 30,
    "theme": "Appreciation",
    "prompt": "Write to a friend about the specific way they make you feel like yourself, not a performance of yourself.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 304,
    "month": "October",
    "day": 31,
    "theme": "Appreciation",
    "prompt": "Write an appreciation letter to someone you'd regret never having told, if this were the only chance.",
    "approach": "Go small. List the unglamorous, specific things \u2014 the showing up, the remembering, the small kindness repeated.",
    "starters": [
      "Here's what I notice about you:",
      "Nobody else does this the way you do:",
      "I appreciate you most for"
    ],
    "tip": "Aim for three concrete examples rather than one big compliment.",
    "letter": {
      "author": "Jane Austen",
      "recipient": "Her sister, Cassandra Austen",
      "year": "December 1798",
      "context": "Jane and Cassandra Austen wrote to each other constantly whenever apart, trading sharp, funny, affectionate observations about daily life. Jane's letters to Cassandra are full of exactly the kind of small noticing that makes someone feel truly seen.",
      "excerpt": "\u201cI do not want people to be very agreeable, as it saves me the trouble of liking them a great deal.\u201d",
      "tieBack": "Austen's letters prove appreciation doesn't need to be solemn to be sincere. Noticing someone well is its own kind of love letter."
    },
    "tier": "full"
  },
  {
    "card": 305,
    "month": "November",
    "day": 1,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone whose single piece of advice quietly altered the course of your life.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 306,
    "month": "November",
    "day": 2,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a person who introduced you to someone who became central to your life \u2014 a partner, friend, or mentor.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 307,
    "month": "November",
    "day": 3,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone who said no to you at the right moment, and changed your direction for the better.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 308,
    "month": "November",
    "day": 4,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a teacher who handed you a book, idea, or opportunity that became a turning point.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 309,
    "month": "November",
    "day": 5,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone whose example gave you permission to live differently than you were raised to.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 310,
    "month": "November",
    "day": 6,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a stranger who, in one conversation, said something you still carry.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 311,
    "month": "November",
    "day": 7,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone who took a chance on you when your r\u00e9sum\u00e9, history, or confidence didn't earn it yet.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 312,
    "month": "November",
    "day": 8,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to the person who taught you the most important lesson you never asked to learn.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 313,
    "month": "November",
    "day": 9,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone whose loss changed how you understand time, love, or your own mortality.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 314,
    "month": "November",
    "day": 10,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a person who modeled a kind of courage you didn't know was possible until you saw it up close.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 315,
    "month": "November",
    "day": 11,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to whoever first told you the truth about yourself that everyone else was too kind to say.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 316,
    "month": "November",
    "day": 12,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone who left your life but left you better than they found you.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 317,
    "month": "November",
    "day": 13,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a person who showed you, just by living it, that a different kind of life was available to you.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 318,
    "month": "November",
    "day": 14,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone whose forgiveness of you changed how you treat your own mistakes.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 319,
    "month": "November",
    "day": 15,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a friend who reentered your life at exactly the right moment, more than once.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 320,
    "month": "November",
    "day": 16,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone whose unwavering belief in you outlasted your own doubt, until yours caught up.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 321,
    "month": "November",
    "day": 17,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a person who ended a relationship, friendship, or chapter with you that needed to end, even though it hurt.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 322,
    "month": "November",
    "day": 18,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to whoever taught you that asking for help was not the failure you assumed it was.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 323,
    "month": "November",
    "day": 19,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone whose illness, recovery, or survival changed how you spend your days now.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 324,
    "month": "November",
    "day": 20,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a person who modeled what a healthy argument, apology, or repair actually looks like.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 325,
    "month": "November",
    "day": 21,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone you met for a single season of life who left a permanent mark on it.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 326,
    "month": "November",
    "day": 22,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to whoever first made you feel unconditionally welcome somewhere.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 327,
    "month": "November",
    "day": 23,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a person whose work, art, or words reached you at exactly the moment you needed reaching.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 328,
    "month": "November",
    "day": 24,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone who challenged a belief you didn't realize you'd never examined.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 329,
    "month": "November",
    "day": 25,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a person whose death taught you something about how you want to live.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 330,
    "month": "November",
    "day": 26,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to whoever first treated your ambition as reasonable instead of excessive.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 331,
    "month": "November",
    "day": 27,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone who walked away from you in a way that, eventually, you understood.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 332,
    "month": "November",
    "day": 28,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to a person who gave you language for a feeling you'd had for years without a name for it.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 333,
    "month": "November",
    "day": 29,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to someone whose ordinary kindness on one ordinary day turned out to matter more than they could have known.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 334,
    "month": "November",
    "day": 30,
    "theme": "Someone Who Changed Your Life",
    "prompt": "Write to the person who changed your life the most. Tell them, plainly, that they did.",
    "approach": "Trace the actual chain of events \u2014 what they did, what changed because of it, where you are now as a result.",
    "starters": [
      "Because of you, I",
      "I don't think you know that",
      "Everything shifted when you"
    ],
    "tip": "Tell them the consequence, not just the gratitude \u2014 show them what their action actually built.",
    "letter": {
      "author": "Ludwig van Beethoven",
      "recipient": "His childhood friend, Franz Wegeler",
      "year": "1801",
      "context": "As Beethoven began losing his hearing, he wrote to Wegeler, the friend from his hometown of Bonn who had known him before fame, before deafness, before any of it. The letter is one of the few places Beethoven let his guard down completely.",
      "excerpt": "He wrote that he wished Wegeler could see into his heart, to understand what his oldest friendships still meant to him \u2014 even as everything else in his life was changing beyond recognition.",
      "tieBack": "Beethoven reached for an old friend at the moment his world was shifting most. The people who knew us first often understand us best."
    },
    "tier": "full"
  },
  {
    "card": 335,
    "month": "December",
    "day": 1,
    "theme": "Letters for the Future",
    "prompt": "Write to whoever finds this letter long after you're gone, about what mattered most in an ordinary year.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 336,
    "month": "December",
    "day": 2,
    "theme": "Letters for the Future",
    "prompt": "Write to a future grandchild you may never meet, about the family stories worth keeping.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 337,
    "month": "December",
    "day": 3,
    "theme": "Letters for the Future",
    "prompt": "Write to the next person who will live in your home, about what made it feel like yours.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 338,
    "month": "December",
    "day": 4,
    "theme": "Letters for the Future",
    "prompt": "Write to a future version of your town, community, or chapter, about what you hope endures.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 339,
    "month": "December",
    "day": 5,
    "theme": "Letters for the Future",
    "prompt": "Write to a child not yet born \u2014 yours, a relative's, or one you'll never meet \u2014 about the world as it is right now.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 340,
    "month": "December",
    "day": 6,
    "theme": "Letters for the Future",
    "prompt": "Write to whoever opens this letter in fifty years, describing one ordinary object on your desk today.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 341,
    "month": "December",
    "day": 7,
    "theme": "Letters for the Future",
    "prompt": "Write to the future caretaker of something you treasure, explaining why it matters.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 342,
    "month": "December",
    "day": 8,
    "theme": "Letters for the Future",
    "prompt": "Write to a future reader about what letter writing itself has meant to you this year.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 343,
    "month": "December",
    "day": 9,
    "theme": "Letters for the Future",
    "prompt": "Write to the next generation of your family about a value you hope survives you.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 344,
    "month": "December",
    "day": 10,
    "theme": "Letters for the Future",
    "prompt": "Write to someone who will read this after a milestone you haven't reached yet \u2014 a wedding, a graduation, a birth.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 345,
    "month": "December",
    "day": 11,
    "theme": "Letters for the Future",
    "prompt": "Write to whoever inherits your bookshelf, garden, or workshop, telling them what to keep and what to let go.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 346,
    "month": "December",
    "day": 12,
    "theme": "Letters for the Future",
    "prompt": "Write to a future version of a place you love, hoping it's still standing, still itself.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 347,
    "month": "December",
    "day": 13,
    "theme": "Letters for the Future",
    "prompt": "Write to the next Postmaster, host, or leader of something you started, passing on what you've learned.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 348,
    "month": "December",
    "day": 14,
    "theme": "Letters for the Future",
    "prompt": "Write to a future reader about what this exact December felt like \u2014 the light, the cold or warmth, the noise.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 349,
    "month": "December",
    "day": 15,
    "theme": "Letters for the Future",
    "prompt": "Write to someone who will face a problem you're facing now, years from now, offering what you learned the hard way.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 350,
    "month": "December",
    "day": 16,
    "theme": "Letters for the Future",
    "prompt": "Write to your future community: the friends you haven't met yet, welcoming them in advance.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 351,
    "month": "December",
    "day": 17,
    "theme": "Letters for the Future",
    "prompt": "Write to whoever reads your old letters one day, explaining why you started writing them in the first place.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 352,
    "month": "December",
    "day": 18,
    "theme": "Letters for the Future",
    "prompt": "Write to the future of a craft, skill, or tradition you practice, hoping someone keeps practicing it.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 353,
    "month": "December",
    "day": 19,
    "theme": "Letters for the Future",
    "prompt": "Write to a future reader describing the people currently in your life, so they aren't forgotten.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 354,
    "month": "December",
    "day": 20,
    "theme": "Letters for the Future",
    "prompt": "Write to whoever opens your time capsule, real or imagined, this year.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 355,
    "month": "December",
    "day": 21,
    "theme": "Letters for the Future",
    "prompt": "Write to a future version of an institution, cause, or community you care about, about what you hope it becomes.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 356,
    "month": "December",
    "day": 22,
    "theme": "Letters for the Future",
    "prompt": "Write to the next person to sit at your table, host a gathering, or keep a tradition alive after you.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 357,
    "month": "December",
    "day": 23,
    "theme": "Letters for the Future",
    "prompt": "Write to a future reader about the question you most want someone to ask, decades from now, about this year.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 358,
    "month": "December",
    "day": 24,
    "theme": "Letters for the Future",
    "prompt": "Write to whoever needs this letter most, without knowing yet who that will be.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 359,
    "month": "December",
    "day": 25,
    "theme": "Letters for the Future",
    "prompt": "Write to the future of your own handwriting, noting how it's changed and what you hope it still says about you.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 360,
    "month": "December",
    "day": 26,
    "theme": "Letters for the Future",
    "prompt": "Write to a descendant about the hardest year you lived through, and how you got to the other side of it.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 361,
    "month": "December",
    "day": 27,
    "theme": "Letters for the Future",
    "prompt": "Write to whoever finds your letters one day, explaining the ritual behind this very page.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 362,
    "month": "December",
    "day": 28,
    "theme": "Letters for the Future",
    "prompt": "Write to a future version of the world, naming one thing you hope it gets right that the present hasn't yet.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 363,
    "month": "December",
    "day": 29,
    "theme": "Letters for the Future",
    "prompt": "Write to the next letter writer in your family, passing the habit along like an heirloom.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 364,
    "month": "December",
    "day": 30,
    "theme": "Letters for the Future",
    "prompt": "Write to whoever reads this last, after every other letter in this box has already been opened.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  },
  {
    "card": 365,
    "month": "December",
    "day": 31,
    "theme": "Letters for the Future",
    "prompt": "Write the final letter of the year: to whoever needs reminding, including yourself, that writing one letter is always how a life of letters begins.",
    "approach": "Write toward someone who doesn't exist yet, or doesn't know you yet. Describe today plainly \u2014 future readers love ordinary detail most.",
    "starters": [
      "By the time you read this,",
      "Right now, the world looks like",
      "I hope you still"
    ],
    "tip": "Be specific about the mundane \u2014 prices, weather, what's playing on the radio. That's what becomes precious later.",
    "letter": {
      "author": "John Adams",
      "recipient": "His wife, Abigail Adams",
      "year": "July 3, 1776",
      "context": "Writing home the day after Congress voted for independence, John Adams tried to imagine how the moment would look to people who hadn't lived through it yet \u2014 people who, in 1776, didn't exist.",
      "excerpt": "\u201cI am apt to believe that it will be celebrated by succeeding generations as the great anniversary festival... from this time forward forevermore.\u201d",
      "tieBack": "Adams wrote a private letter to his wife and somehow also wrote to everyone who'd come after them. A letter can hold both at once."
    },
    "tier": "full"
  }
];

// Helper function to get tier-appropriate cards
export const getAccessibleCards = (userTier) => {
  const tierLevels = { free: 0, basic: 1, full: 2 };
  const userLevel = tierLevels[userTier] || 0;
  
  return PROMPT_CARDS.filter(card => {
    const cardLevel = tierLevels[card.tier] || 0;
    return cardLevel <= userLevel;
  });
};

// Get a random card based on user's tier
export const getRandomCard = (userTier, excludeIds = []) => {
  const accessible = getAccessibleCards(userTier).filter(c => !excludeIds.includes(c.card));
  if (accessible.length === 0) return null;
  return accessible[Math.floor(Math.random() * accessible.length)];
};

// Get cards by theme
export const getCardsByTheme = (theme, userTier) => {
  return getAccessibleCards(userTier).filter(card => card.theme === theme);
};

// Get today's card based on day of year
export const getTodaysCard = (userTier) => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now - start;
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);
  
  const accessible = getAccessibleCards(userTier);
  if (accessible.length === 0) return null;
  
  // Find card for today, or cycle through accessible cards
  const todayCard = accessible.find(c => c.card === dayOfYear);
  if (todayCard) return todayCard;
  
  // Fallback: cycle through accessible cards
  return accessible[dayOfYear % accessible.length];
};

export default { DECK_THEMES, PROMPT_CARDS, getAccessibleCards, getRandomCard, getCardsByTheme, getTodaysCard };
